import { render, staticRenderFns } from "./StoreProductForm.vue?vue&type=template&id=80dd0322"
import script from "./StoreProductForm.vue?vue&type=script&lang=js"
export * from "./StoreProductForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports